(() => {
  const storageKey = 'auras_vip_popup_dismissed_until';
  const joinedKey = 'auras_vip_joined';

  const canUseStorage = () => {
    try {
      localStorage.setItem('__auras_test', '1');
      localStorage.removeItem('__auras_test');
      return true;
    } catch {
      return false;
    }
  };

  const unlockScroll = () => {
    document.body.classList.remove('auras-vip-popup-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  };

  const initPopup = (popup) => {
    if (popup.dataset.aurasVipPopupInitialized === 'true') return;
    popup.dataset.aurasVipPopupInitialized = 'true';

    const hasStorage = canUseStorage();
    const alreadyJoined =
      hasStorage && localStorage.getItem(joinedKey) === 'true';

    /* Always unlock page on load */
    unlockScroll();

    if (alreadyJoined) {
      popup.hidden = true;
      return;
    }

    const delay = Number(popup.dataset.delay || 3000);

    const open = () => {
      popup.hidden = false;
      document.body.classList.add('auras-vip-popup-open');
    };

    const close = () => {
      popup.hidden = true;
      unlockScroll();
    };

    popup.querySelectorAll('[data-auras-vip-popup-close]').forEach((btn) => {
      btn.addEventListener('click', close);
    });

    popup.addEventListener('click', (e) => {
      if (e.target === popup) close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    window.addEventListener('pageshow', unlockScroll);

    window.addEventListener('beforeunload', unlockScroll);

    setTimeout(open, delay);
  };

  document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('[data-auras-vip-popup]')
      .forEach(initPopup);
  });

  document.addEventListener('shopify:section:load', () => {
    document
      .querySelectorAll('[data-auras-vip-popup]')
      .forEach(initPopup);
  });
})();